import AdminPageLayout from '@/components/layout/AdminPageLayout';
import ProfileForm from '@/components/user/ProfileForm';

function ProfileDetails() {
  return (
    <AdminPageLayout title="Profile Details" fullWidth={false} testId="profile-details">
      <ProfileForm />
    </AdminPageLayout>
  );
}

export default ProfileDetails;
